import Swal from "sweetalert2";
import { api } from "../infra/api";
import { URLS } from "../infra/URLS";
import { IUser } from "./types";

export function setUserLocalStorage(user: IUser | null) {
  localStorage.setItem("user", JSON.stringify(user));
}

export function getUserLocalStorage() {
  const json = localStorage.getItem("user");

  if (json) {
    return JSON.parse(json);
  }
}

export async function LoginRequest(username: string, password: string) {
  try {
    const request = await api.post(URLS.LOGIN_API, {
      username,
      password,
    });

    return request.data;
  } catch (error: any) {
    if (error.response.status === 401 || error.response.status === 404) {
      return Swal.fire({
        title: "Erro",
        text: `Verifique se o login e a senha estão corretos ou se o usuário se encontra cadastrado e ativo!`,
        icon: "error",
        position: "center",
        confirmButtonText: "Ok",
        confirmButtonColor: "#F27474",
      });
    } else if (error.response.status === 500) {
      return Swal.fire({
        title: "Ocorreu um erro",
        text: "Erro: Falha na comunicação com o servidor!",
        icon: "error",
        position: "center",
        confirmButtonText: "Ok",
        confirmButtonColor: "#F27474",
      });
    }
    // return alert(error.message);
  }
}
